import { MutationFunction, useMutation } from '@tanstack/react-query';
import { createAxiosInstance } from 'api/request';
import { MutationHook } from 'utils/hooks/mutations/types';

type RequestReturnType = void;
type RequestParameters = { receiveEmails: boolean };

const request: MutationFunction<RequestReturnType, RequestParameters> = async ({ receiveEmails }) =>
{
  await createAxiosInstance().post('/user/notifications', { subscriptions: receiveEmails });
};

const useToggleEmailNotificationsMutation: MutationHook<RequestReturnType, RequestParameters> = (options) =>
{
  return useMutation({
    mutationFn: request,
    ...options,
  });
};


export default useToggleEmailNotificationsMutation;
